module.exports = __webpack_public_path__ + "img/6_140.cb1f7110.png";